import { render } from "./ScoringInternal.vue?vue&type=template&id=2734174f&scoped=true"
import script from "./ScoringInternal.vue?vue&type=script&lang=js"
export * from "./ScoringInternal.vue?vue&type=script&lang=js"

import "./ScoringInternal.vue?vue&type=style&index=0&id=2734174f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2734174f"]])

export default __exports__